//WEBAPI_BASE_URL : "http://localhost:57578/api",
//WEBAPI_BASE_URL: "https://sewebapi.azurewebsites.net/api",
const env = {	
	WEBAPI_BASE_URL: "http://localhost:57578/api",
    DEVTOOLS_ENABLED : true,
    APPLICATION_ID: 'e10fd47c-09ed-4094-a305-fb20bb49af41'
}


export default env;


// WEBPACK FOOTER //
// ./src/configs/config.dev.js